import { createAsyncThunk } from '@reduxjs/toolkit';

import axiosInterceptorInstance from './axiosInterceptorInstance';

export const getBankList = createAsyncThunk('bank/getBankList', async () => {
  try {
    const relativeUrl = 'Bank/GetBankList/';
    const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
    const response = await axiosInterceptorInstance.get(apiUrl);

    return response.data;
  } catch (error) {
    return error;
  }
});
